module.exports = __webpack_public_path__ + "img/pr-12.21f466b6.png";